export const no = {
    "n1": "Hjemmeside",
    "n2": "Bestill",
    "n3": "transaksjon",
    "n4": "team",
    "n5": "min",
    "t1": "noe gikk galt",
    "t2": "Kopiert vellykket",
    "t3": "Vennligst fyll ut informasjonen fullstendig",
    "t4": "Laster inn …",
    "t5": "Innlogging vellykket",
    "t6": "Poengsummen må være større enn 3 for å sende inn",
    "t7": "Innlevering vellykket",
    "t8": "Utilstrekkelig balanse, kan ikke motta",
    "t9": "Innsending mislyktes",
    "t10": "Vennligst bind adressen først, og du vil bli omdirigert til den personlige sentersiden.",
    "t11": "Adressen er bundet, kontakt kundeservice for å endre den.",
    "t12": "Endring vellykket",
    "t13": "Endring mislyktes",
    "t14": "Ta kontakt med kundeservice for å endre passordet ditt",
    "t15": "Passordformatfeil",
    "t16": "Trekk tilbake",
    "t17": "Det maksimale beløpet som kan tas ut",
    "t18": "Minimum uttak",
    "t19": "To passord er inkonsekvente",
    "t20": "Tips",
    "t21": "Kan ikke hoppe for øyeblikket",
    "t22": "Passordformatfeil",
    "t23": "Registrering vellykket",
    "t24": "Vennligst skriv inn retningsnummer",
    "t25": "Ikke mer",
    "l1": "Språk",
    "l2": "Vennligst skriv inn kontonummer",
    "l3": "Vennligst skriv inn passord",
    "l4": "husk",
    "l5": "Logg inn",
    "l6": "Gå til registrering",
    "l7": "Ingen konto",
    "l8": "Mobilnummer",
    "l9": "Kallenavn",
    "l10": "Passord",
    "l11": "Bekreft passord",
    "l12": "Invitasjonskode",
    "l13": "Registrer deg",
    "l14": "Har allerede en konto",
    "l15": "Gå til pålogging",
    "l16": "Vennligst skriv inn et 6-16 sifret passord",
    "bz1": "hjelp",
    "bz2": "FAQ",
    "bz3": "handelsregler",
    "bz4": "Hvordan ta ut penger",
    "bz5": "Hvordan lades opp",
    "bz6": "1. Hva er Amazon Review RoBoT?",
    "bz7": "Amazon Review RoBoT er et markedsføringsselskap som hjelper Amazon Review RoBoT-nettbutikkhandlere over hele verden med å få flere ordresalg og øke nettleserdataene til Amazon Review RoBoT-nettbutikker. Vi er forpliktet til å etablere en treparts lønnsom markedsførings- og promoteringsmodell mellom Amazon Review RoBoT, selgere og forbrukere. Kombinert med den nyeste P2P-blokkjedeteknologien, kobles forbrukere og selgere raskt sammen gjennom USDT (TRC20, ERC20). Registrerte brukere kan få provisjoner på bestillinger, mens selgere kan øke butikkens salgsdata. Det er den siste profittmodellen i Internett-blokkjedemodellen!",
    "bz8": "2. Hvordan fungerer Amazon Review RoBoT?",
    "bz9": "Den daglige tilbakemeldingen fra Amazon Review RoBoT viser at produkter som trenger forbedring selges i Amazon Review RoBoT. Brukerne trenger bare å klikke på bestillingen enkelt, og systemet genererer automatisk et bestillingsabonnement. Brukere betaler ordrebeløpet via blockchain USDT og mottar daglige provisjoner.",
    "bz10": "3.Hvorfor er prisene på samme valuta forskjellige i to transaksjoner?",
    "bz11": "Prisforskjeller er forårsaket av alle faktorer som ikke bidrar til fri sirkulasjon av valutaer, inkludert hastigheten på valutaoverføringer, nettverksforhold, valutatilgangsbegrensninger, valutagjenkjenning av folk i forskjellige regioner, og til og med typene handelspar som tilbys av børser, transaksjoner osv. Derfor kan samme valuta ha prisforskjeller i forskjellige transaksjoner.",
    "bz12": "4. Investeringsoverskudd?",
    "bz13": "Jo høyere pris på varen du får, jo høyere fortjeneste får du på bestillingen. Samtidig distribuerer Amazon Review RoBoT tilfeldig store provisjonsordrer.",
    "bz14": "Hver dag genererer og distribuerer systemet automatisk 60 produktbestillinger til brukerne. Brukere fullfører betalingen for hver bestilling gjennom USDT og mottar en provisjon på 0,6 %. Store provisjonsordrer tildeles tilfeldig.",
    "bz15": "USDT kan trekkes tilbake etter 60 bestillinger. (Hvis 60 bestillinger ikke fullføres, vil systemet automatisk stoppe til dagens gjenværende bestillinger)",
    "bz16": "Hver konto kan bare være bundet til én USDT-konto. Hvis det oppstår en feil, vennligst kontakt kundeservice.",
    "bz17": "Etter å ha fullført leveringen av daglige bestillinger, kan du ta ut penger normalt. Pengene kommer innen 24 timer etter at uttaket startet, og det er ingen uttaksgrense.",
    "bz18": "Før du lader, vennligst bind din uttaksadresse (støtter TRC-20) USDT-adresse. Du kan klikke på lade opp på APP-en eller nettsiden og velge blokkjeden (TRC-20) du bruker for å lade opp.",
    "bz19": "Gjensidig opplading eller gjensidig overføring er ikke tillatt mellom relaterte kontoer. Dette er ondsinnet oppførsel som fanger ordre og påvirker plattformens operasjonsreglene alvorlig. Hvis slik oppførsel blir funnet, vil systemet umiddelbart fryse kontoen og diskvalifisere arbeidet.",
    "ty1": "OK",
    "ty2": "Avbryt",
    "ty3": "Send inn",
    "ty4": "TRC20-adresse",
    "ty5": "ERC20-adresse",
    "s1": "Akkumulert inntekt",
    "s2": "tjeneste",
    "s3": "Om oss",
    "s4": "hjelp",
    "s5": "Partnere",
    "s6": "mine tjenester",
    "d1": "Ikke fullført",
    "d2": "Fullført",
    "d3": "Ingen data ennå",
    "d4": "Bestillingsnummer",
    "d5": "åpningstider",
    "d6": "Beløp",
    "d7": "Aktuelt antall oppgaver",
    "d8": "forventet avkastning",
    "d9": "trenger fortsatt",
    "d10": "Vurdering",
    "j1": "Kontosaldo",
    "j2": "Handelsintroduksjon",
    "j3": "Amazon Review RoBoT bruker tilbakemeldinger fra Amazon Review RoBoT hver dag for å vise frem produkter som selges av Amazon Review RoBoT som trenger forbedring. Brukere trenger bare å klikke på ordren og systemet vil automatisk generere en ordresignatur. Brukere betaler ordrebeløpet gjennom USDT-blokkjeden og kan motta mer enn 0,6 % provisjon hver gang, og systemet distribuerer tilfeldig store belønningsordrer.",
    "j4": "Begynn å matche",
    "j5": "Dagens inntjening",
    "j6": "Fullført",
    "j7": "Totalt antall oppgaver",
    "td1": "balanse",
    "td2": "kommisjon",
    "td3": "motta",
    "td4": "totalt antall personer",
    "td5": "Bruker",
    "td6": "Bidra",
    "td7": "Mengde",
    "td8": "Status",
    "g1": "Ta ut kontanter",
    "g2": "Lad opp",
    "g3": "Inviter venner",
    "g4": "Inviter nå",
    "g5": "For hver fortjeneste vennene dine tjener etter at de har registrert seg, vil du motta en tilsvarende provisjon.",
    "g6": "personlig informasjon",
    "g7": "Fondsdetaljer",
    "g8": "Lad opp rekorden",
    "g9": "Uttaksregister",
    "g10": "Språk",
    "g11": "Logg ut",
    "g12": "Er du sikker på at du vil logge ut?",
    "yh1": "Brukerinformasjon",
    "yh2": "Endre",
    "yh3": "innstillinger",
    "yh4": "telefon",
    "yh6": "Opprinnelig passord",
    "yh7": "nytt passord",
    "mx1": "Provisjonsinnkreving",
    "mx2": "inntekt",
    "mx3": "Tilbaketrekking avvist",
    "mx4": "tid",
    "mx5": "Opplading vellykket",
    "mx6": "Avvist",
    "mx7": "Venter",
    "mx8": "Uttaksadresse",
    "mx9": "tilgjengelig saldo",
    "mx10": "Faktisk ankomst",
    "mx11": "Vennligst skriv inn uttaksbeløpet",
    "cz1": "Innskuddsadressen støtter kun ERC20, og minimumsbeløpet for innskudd er 20USDT.",
    "cz2": "Kopier",
    "cz3": "Valutavalg for Fiat",
    "cz4": "betale",
    "cz5": "Innskuddsadressen støtter kun TRC20-USDT, og minimumsbeløpet for innskudd er 20USDT.",
    "cz6": "Innskuddsadressen støtter kun ERC20, og minimumsbeløpet for innskudd er 20USDT.",
    "qy1": "retningsnummer",
    "yq1": "Inviter venner",
    "yq2": "Invitasjonskode",
    "yq3": "Inviter venner og nyt enorme fordeler",
    "yq4": "Gå og inviter",
    "zf1": "Lademetode",
    "zf2": "Velg en lademetode",
    "zf3": "handle valutaer",
    "zf4": "handelsnettverk",
    "zf5": "Gå til handel",
    "zf6": "Kopiert vellykket",
    "zf7": "handle valutaer",
    "zf8": "Vennligst bruk",
    "zf9": "Overfør penger til adressen nedenfor for å fullføre oppladingen.",
    "zf10": "Transaksjonsvaluta",
    "zf11": "Kopier",
    "zf12": "Vennligst sjekk adressen nøye. Hvis du overfører det feil, vil du ikke kunne hente det.",
    "zf13": "Ankomsttid",
    "zf14": "Ca 1-5 minutter",
    "zf15": "Minimum oppladingsbeløp",
    "a1": "Butikkmarkedsføringssenter",
    "a2": "Amazon Market Robot-butikkmarkedsføringssenteret er en helt ny seksjon designet for å hjelpe selgere raskt å øke salget og rosprisene for produktene deres i løpet av kort tid, og dermed øke vekten på produktene og øke eksponeringen ytterligere; brukere hjelper selgere ved å fullføre ulike oppgaver og motta tilsvarende belønninger, og dermed oppnå en vinn-vinn-situasjon for begge parter.",
    "a3": "For tiden har systemet 30 millioner brukere og 5 millioner selgere, og antallet produkter som markedsføres på plattformen hver dag når 70 millioner; noen kjøpmannsprodukter har økt butikksalget med 60 % ved å koble til markedsføringssentersystemet; og plattformbrukerne av markedssentersystemet trenger bare å klikke på bestillingen, og markedssentersystemet vil automatisk generere en ordresignatur. Etter at brukeren har forhåndsbetalt ordrebeløpet, fullføres den virtuelle transaksjonen, og midlene returneres umiddelbart til brukerkontoen. En ekstra provisjon på mer enn 0,6 % kan oppnås hver gang. Systemet vil også tilfeldig tildele store belønningsordrer for å øke brukerens provisjon.",
    "a4": "Amazon Market Robot legger stor vekt på behovene til brukere og selgere, og fortsetter å optimalisere og forbedre markedssentersystemet.",
    // 客服
    "kf1": "Online kundeservice",
    "kf2": "Manuell kundeservice uttak",
    "kf3": "Du kan klikke her for å kontakte manuell kundeservice for uttak",
    "kf4": "Manuell kundeservice innskudd",
    "kf5": "Du kan klikke her for å kontakte manuell kundeservice for innskudd",
    // 支付选项弹窗
    "zf16": "For bankkorttransaksjoner, vennligst kontakt kundeservice",
    "zf17": "Kontakt kundeservice"
  }
  